import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import Pagination from '../../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import { Loader } from '../../components/ModalsCommonFunctions';
import { CModal } from '@coreui/react';

const CreateHostelIncharge = () => {
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    // const sectionMasterId = localStorage.getItem("sectionMasterId")
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxios = generateAxiosInstance()
    const initialFormState = {
        instituteMasterId: instituteMasterId,
        // sectionMasterId: sectionMasterId,
        name: "",
        address: "",
        city: "",
        district: "",
        state: "",
        pincode: "",
        email: "",
        contactNumber: ""
    }

    const [InchargeData, setInchargeData] = useState(initialFormState)
    const [InchargeList, setInchargeList] = useState([])

    const [editId, setEditId] = useState(null)

    const [StateList, setStateList] = useState([])
    const [CityList, setCityList] = useState([])
    const [DistList, setDistList] = useState([])
    const [showDetails, setShowDetails] = useState("");
    const [visible, setVisible] = useState(false);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [nameSort, setNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["hostelInchargeId", "name", "email", "contactNumber"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getInchargeList();
        }
    }, [searchValue]);


    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setInchargeList(await searchArray("I", `/get-hostel-incharge?instituteMasterId=${instituteMasterId}`, searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(InchargeList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(InchargeList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > InchargeList.length) {
            endIndex = InchargeList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(InchargeList.slice(startIndex, endIndex));
    }, [InchargeList, currPage, itemsPerPage]);

    const getStateList = () => {
        const apiUrlForInstitute = `/all-states`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstitute)
            .then(response => {
                setStateList(response.data.result.map((board) => {
                    return {
                        value: board.id,
                        label: board.stateName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getInchargeList = async () => {
        const apiUrl = `/get-hostel-incharge?instituteMasterId=${instituteMasterId}`;
        try {
            const response = await authorizedAxiosInstitute.get(apiUrl)
            setInchargeList(response.data.result)
        } catch (error) {
            setInchargeList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    useEffect(() => {
        getStateList()
        getInchargeList()
    }, [])

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInchargeData((prevData) => {
            if (name === 'contactNumber') {
                // Filter out non-numeric characters and limit to 10 digits
                const filteredValue = value.replace(/[^0-9]/g, '').slice(0, 10);
                return {
                    ...prevData,
                    [name]: filteredValue,
                };
            } else if (name === 'pincode') {
                const filteredValue = value.replace(/[^0-9]/g, '').slice(0, 6);
                return {
                    ...prevData,
                    [name]: filteredValue
                }
            } else {
                return {
                    ...prevData,
                    [name]: value
                }
            }
        });
    };

    const handleChangeState = (selectedOptions) => {
        setInchargeData((prevData) => {
            return {
                ...prevData,
                state: selectedOptions?.label,
            }
        })

        const apiUrlForInstitute = `/state-wise-district-city?id=${selectedOptions?.value}`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstitute)
            .then(response => {
                setCityList(response.data.cities.map((board) => {
                    return {
                        value: board.id,
                        label: board.cityName
                    }
                }))
                setDistList(response.data.districts.map((board) => {
                    return {
                        value: board.id,
                        label: board.districtName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({
                    text: errorMsg
                })
            });
    }

    const handleChangeDist = (selectedOptions) => {
        setInchargeData((prevData) => {
            return {
                ...prevData,
                district: selectedOptions.label,
            }
        })
    }

    const handleUpdateInstitute = (Incharge) => {
        setInchargeData(prevData => ({
            ...prevData,
            // instituteMasterId: instituteMasterId,
            // sectionMasterId: sectionMasterId,
            name: Incharge.name,
            address: Incharge.address,
            city: Incharge.city,
            district: Incharge.district,
            state: Incharge.state,
            pincode: Incharge.pincode,
            email: Incharge.email,
            contactNumber: Incharge.contactNumber
        }));
        setEditId(Incharge.id)
    }

    //error
    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)

    const validateForm = () => {
        const mandatoryFields = Object.keys(InchargeData).filter(field => !['address', 'state', 'district', 'city', 'pincode'].includes(field));

        const contactNumberValid = InchargeData.contactNumber.toString().length == 10;

        return Object.values(error).every((error) => error === '') &&
            mandatoryFields.every((field) => typeof InchargeData[field] === "string" ? InchargeData[field] !== '' : InchargeData[field]?.length !== 0) &&
            contactNumberValid;
    };

    const validateFalse = () => {
        for (const [key, value] of Object.entries(InchargeData)) {
            if (key !== 'address' && key !== 'state' && key !== 'district' && key !== 'city' && key !== 'pincode') {
                if (value == '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        emailRegex.test(InchargeData.email) ?
            setError((prevData) => {
                return {
                    ...prevData,
                    email: '',
                }
            })
            : setError((prevData) => {
                return {
                    ...prevData,
                    email: 'Enter valid Email ID',
                }
            })

        if (InchargeData.contactNumber.length > 0 && InchargeData.contactNumber.length < 10) {
            setError((prevData) => ({
                ...prevData,
                contactNumber: 'Contact number must be at least 10 characters long.',
            }));
        }
    }

    const checking = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(InchargeData.email)
    }

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(InchargeData)) {
                if (key !== 'address' && key !== 'state' && key !== 'district' && key !== 'city' && key !== 'pincode') {
                    if (value == '' || value.length == 0) {
                        setError((prevData) => {
                            return {
                                ...prevData,
                                [key]: 'This field is required.',
                            }
                        })
                    } else {
                        setError((prevData) => {
                            return {
                                ...prevData,
                                [key]: '',
                            }
                        })
                    }
                }
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            emailRegex.test(InchargeData.email) ?
                setError((prevData) => {
                    return {
                        ...prevData,
                        email: '',
                    }
                })
                : setError((prevData) => {
                    return {
                        ...prevData,
                        email: 'Enter valid Email ID',
                    }
                })

            if (InchargeData.contactNumber && InchargeData.contactNumber.length > 0 && InchargeData.contactNumber.length < 10) {
                setError((prevData) => ({
                    ...prevData,
                    contactNumber: 'Contact number must be at least 10 characters long.',
                }));
            } else if (InchargeData.contactNumber == '' || InchargeData.contactNumber == 0) {
                setError((prevData) => ({
                    ...prevData,
                    contactNumber: 'This field is required.',
                }));
            } else {
                setError((prevData) => ({
                    ...prevData,
                    contactNumber: '',
                }));
            }
        }
    }, [InchargeData])

    const addIncharge = async () => {
        const apiUrl = `/add-hostel-incharge`;
        if (validateForm() && checking()) {
            try {
                setLoading(true);
                const response = await authorizedAxiosInstitute.post(apiUrl, InchargeData)
                await getInchargeList();

                setSaveId(response.data.createdHostelIncharge.id);
                setNameSort(null);
                setInchargeData(initialFormState);
                setError(initialErrorState);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            validateFalse();
        }
    }

    const updateIncharge = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/edit-hostel-incharge?id=${editId}`;
                const response = await authorizedAxiosInstitute.put(apiUrl, InchargeData);
                await getInchargeList();
                setEditId(null);
                setInchargeData(initialFormState);
                setError(initialErrorState);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({
                    text: errorMsg
                })
            } finally {
                setLoading(false);
            }
        } else {
            validateFalse();
        }
    }

    const deleteIncharge = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-hostel-incharge?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, InchargeList.length);
                await getInchargeList();
                setCurrPage(page);

                setNameSort(null);
                Swal.fire({ text: response.data.message });
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const handleReset = () => {
        setEditId('');
        setNameSort(null);
        setInchargeData(initialFormState);
        setError(initialErrorState)
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Create Incharge</span></li>
                        </ol>
                    </nav>
                </div>
                <div id='scroll-up'></div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-user-plus"></i>Create Incharge</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <label for="name" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Incharge Name :</label>
                                                    <input type="text" className="form-control" name="name" value={InchargeData.name} onChange={handleInputChange} />
                                                    {error.name && <p style={{ color: 'red' }}>{error.name}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="address" className="col-form-label">Address :</label>
                                                    <input type="text" className="form-control" name="address" value={InchargeData.address} onChange={handleInputChange} />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="state" className="col-form-label">State :</label>
                                                    <Select
                                                        value={InchargeData.state == '' ? null : StateList.filter(option =>
                                                            InchargeData.state && InchargeData.state == option.label && (option.value)
                                                        )[0]}
                                                        name="state"
                                                        options={StateList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeState}
                                                    />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="district" className="col-form-label">District :</label>
                                                    <Select
                                                        value={InchargeData.district == '' ? null : DistList.filter(option =>
                                                            InchargeData.district && InchargeData.district == option.label && (option.value)
                                                        )[0]}
                                                        name="district"
                                                        options={DistList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeDist}
                                                    />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="city" className="col-form-label">City :</label>
                                                    <input type="text" className="form-control" name="city" value={InchargeData.city} onChange={handleInputChange} />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="pincode" className="col-form-label">Pincode :</label>
                                                    <input type="text" min="0" className="form-control custom-input" name="pincode" value={InchargeData.pincode} onChange={handleInputChange} />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="contactNumber" className="col-form-label"><span style={{ color: "red" }}>*</span>Contact Number :</label>
                                                    <input type="text" min="0" className="form-control custom-input" name="contactNumber" value={InchargeData.contactNumber} onChange={handleInputChange} />
                                                    {error.contactNumber && <p style={{ color: 'red' }}>{error.contactNumber}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="email" className="col-form-label"><span style={{ color: "red" }}>*</span>Email-Id :</label>
                                                    <input type="email" className="form-control" name="email" value={InchargeData.email} onChange={handleInputChange} />
                                                    {error.email && <p style={{ color: 'red' }}>{error.email}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6 d-flex justify-content-end mt-3">
                                                    {!editId && <button className="btn btn-primary" type="button" onClick={addIncharge}>Save</button>}
                                                    {editId && (<button className="btn btn-success approve_icon m-0" type="button" onClick={updateIncharge} disabled={!editId}>Update</button>)}
                                                </div>
                                                <div className="col-md-6 mt-3">
                                                    <button className="btn btn-danger delete_icon delete-icon" type="reset" onClick={handleReset}>Reset</button>
                                                </div>


                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">Incharge Id</th>
                                                                        <th scope="col">
                                                                            Incharge Name
                                                                            <SortIcon sortState={nameSort} setSortState={setNameSort} setData={setInchargeList} setCurrPage={setCurrPage} sortingPath={"name"} />
                                                                        </th>
                                                                        <th scope="col">Email</th>
                                                                        <th scope="col" className='ins_id'>Phone No</th>
                                                                        <th scope="col">Full Details</th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((Incharge, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{Incharge.hostelInchargeId}</td>
                                                                                        <td>{Incharge.name}</td>
                                                                                        <td>{Incharge.email}</td>
                                                                                        <td>{Incharge.contactNumber}</td>
                                                                                        {/* <td className='ins_id'>{Incharge.contactNumber}</td> */}
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setShowDetails(Incharge);
                                                                                                setVisible(!visible)
                                                                                            }}><i class="fa fa-eye" ></i></button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" style={{ marginRight: '5px' }} onClick={() => {
                                                                                                handleUpdateInstitute(Incharge);
                                                                                                if (Incharge.state) {
                                                                                                    handleChangeState(StateList.find(i => i?.label === Incharge?.state));
                                                                                                }
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }
                                                                                            }><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === Incharge.id} onClick={() => deleteIncharge(Incharge.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Incharge Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={InchargeList.length} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

            {visible && <CModal
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="LiveDemoExampleLabel"
                onIni
            >
                <div className="book book-modal">
                    <h2 className='table-header-like'>Full Details</h2>
                    <div className='page'>
                        <p>Incharge Id: {showDetails.hostelInchargeId}</p>
                        <p>Incharge Name: {showDetails.name}</p>
                        {showDetails.address && <p>Address: {showDetails.address}</p>}
                        {showDetails.state && <p>State: {showDetails.state}</p>}
                        {showDetails.district && <p>District: {showDetails.district}</p>}
                        {showDetails.city && <p>City: {showDetails.city}</p>}
                        {showDetails.pincode && <p>Pincode: {showDetails.pincode}</p>}
                        <p>Contact Number: {showDetails.contactNumber}</p>
                        <p>Email: {showDetails.email}</p>
                        {showDetails.password && <p>Pincode: {showDetails.password}</p>}
                    </div>
                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                        Close
                    </button>
                </div>
            </CModal>}
        </>
    )
};

export default CreateHostelIncharge;